<template>
  <div class="firstPage">
    <el-row >
      <el-carousel class="banner" indicator-position="none" :autoplay="true" :interval="3000">
        <el-carousel-item v-for="(item, index) in banners" :key="index" class="bannerItem">
          <div class="carousel">
            <img class="carouselImg" :src="item" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <el-row :gutter="20" class="special">
      <el-col :span="8" v-for="(item,index) in specials" :key="index">
        <el-card>
          <div class="specialBox">
            <div>
              <img :src="item.img" />
            </div>
            <div class="specWord">
              <div class="title">
                <span :style="{color:item.titlrColor}">
                  {{item.title}}
                </span>
              </div>
              <div class="content">
                <span>
                  {{item.content}}
                </span>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="overWord">
      <span>
        沉浸式学习是一种学习方式，以学习者为中心，以认知迁移为基础，以绩效提升为目标。通过设计学习过程，推动学习者进入沉浸式学习状态，更有效的实现学习者的认知迁移与行为改变。
      </span>
    </el-row>
  </div>

</template>

<script>
export default {
  name: "firstPage",
  data() {
    return {
      banners: [
        "../../static/imgs/banners/banner1.jpg",
        "../../static/imgs/banners/banner1.jpg",
      ],
      specials: [
        {
          img: "/static/imgs/firstPage/blue.jpg",
          title: "特点1：重视认知迁移的过程",
          titlrColor: "#002060",
          content:
            "基于学习者认知水平、以原有认知结构为基础，设计学习过程。包括激发学习者动力、保持学习者注意力，激活情绪反应，浮现原有认知结构，浮现原有认知雷达，实现认知迁移",
        },
        {
          img: "/static/imgs/firstPage/orange.jpg",
          title: "特点2：重视学习者的投入状态",
          titlrColor: "#002060",

          content:
            "最好的学习状态即全身心投入的沉浸状态，以学员为中心，将学员带入沉浸状态",
        },
        {
          img: "/static/imgs/firstPage/gray.jpg",
          title: "特点3：重视学习情境的塑造",
          titlrColor: "red",

          content: "构建动态、复杂的真实场景，让学习者在情境中学习",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.firstPage {
  background-color: whitesmoke;
  padding-bottom: 30px;
}
.carousel {
  width: 100%;
  height: 100%;
  .carouselImg {
    width: 100%;
    height: 100%;
  }
}

.banner {
  height: 300px;
  .bannerItem{
     width: 100%;
    height: 100%;
  }
}
.special {
  margin-top: 30px;
}
.specialBox {
  display: flex;
  flex-flow: row nowrap;
  text-align: left;
  height: 120px;

  .specWord {
    margin-left: 10px;
    .title {
      font-size: 15px;
    }
    .content {
      font-size: 13px;
      margin-top: 10px;
    }
  }
}
.overWord {
  margin: 20px 50px 0 50px;
  color: darkblue;
  text-align: left;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/firstPage.vue